/**
 * @param {array} packages :- total amount of packages
 * @returns {number}
 */
export const getTotalAmountOfPackages = (packages) => {
    return packages.reduce((acc, pkg) => acc + pkg.count, 0);
};
